var _style, _path, _path2, _g, _g2, _g3, _path3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyLeadersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 65,
    fill: "none"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".B{color-interpolation-filters:sRGB}.C{flood-opacity:0}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.864 49.475L90.993 0H49.475L0 49.475h41.864z",
    fill: "#333330"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.779 64.006L107 15H65.5L15.915 64.006h41.864z",
    fill: "#d60e15"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#AX)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 35a4 4 0 014-4h19v25H16a4 4 0 01-4-4V35z",
    fill: "#ccc"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#BX)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 35a4 4 0 00-4-4H65v25h19a4 4 0 004-4V35z",
    fill: "#ccc"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#CX)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 14a4 4 0 014-4h22a4 4 0 014 4v42H35V14z",
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M49.696 34.976v8.928h2.096V32h-1.664c-.224.976-.592 1.328-2.128 1.328v1.648h1.696z",
    fill: "#474747"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#7a7979"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.778 41.234v-.896c0-.546.168-.826.672-.826.518 0 .686.28.686.826v1.078c0 .532-.154.7-.658.7h-1.022v1.624h1.134c.504 0 .644.168.644.672v1.75c0 .56-.21.868-.714.868-.532 0-.756-.308-.756-.868v-1.428H22v1.582c0 1.358.504 2.324 2.38 2.324h.294c1.708 0 2.436-.952 2.436-2.366v-2.03c0-.994-.588-1.344-1.036-1.47.434-.168.896-.672.896-1.694v-.868c0-1.484-.588-2.212-2.436-2.212h-.168c-1.82 0-2.282.91-2.282 2.212v1.022h1.694z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M79.516 48.514v-3.416h-1.764v1.848h-2.128c0-.364.168-.882 1.358-2.184l1.19-1.358c.798-.938 1.176-1.638 1.176-2.898v-.168c0-1.47-.644-2.338-2.506-2.338h-.28c-1.75 0-2.268 1.008-2.268 2.212v1.498h1.75v-1.33c0-.588.182-.868.7-.868.532 0 .714.266.714.868v.196c0 .784-.182 1.12-.784 1.932l-1.12 1.47C74.308 45.588 74 46.442 74 47.73v.784h5.516z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "AX",
    x: 9.605,
    y: 29.803,
    width: 27.789,
    height: 29.789,
    filterUnits: "userSpaceOnUse",
    className: "B"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "A",
    className: "C"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "B"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "B",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "A"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "BX",
    x: 62.605,
    y: 29.803,
    width: 27.789,
    height: 29.789,
    filterUnits: "userSpaceOnUse",
    className: "B"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "A",
    className: "C"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "B"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "B",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "A"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "CX",
    x: 32.605,
    y: 8.803,
    width: 34.789,
    height: 50.789,
    filterUnits: "userSpaceOnUse",
    className: "B"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "A",
    className: "C"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "B"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "B",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "A"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic"
  })))));
}
SvgEmptyLeadersIcon.displayName = 'EmptyLeadersIcon';
export default SvgEmptyLeadersIcon;